export const ADD_SUBJECT = 'ADD_SUBJECT';
export const GET_SUBJECTS = 'GET_SUBJECTS';
export const GET_UNIQUE_SUBJECT = 'GET_UNIQUE_SUBJECT';
export const EDIT_SUBJECT = 'EDIT_SUBJECT';
export const DELETE_SUBJECT = 'DELETE_SUBJECT';
export const DISABLE_SUBJECT = 'DISABLE_SUBJECT';